import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useAuth from './useAuth';

export default function useEmployees() {
    const { request } = useAuth();
    const queryClient = useQueryClient();

    const employeeQuery = useQuery({
        queryKey: ['employee'],
        queryFn: () => request.get('/employee/getEmployees').then((res) => res.data),
    });

    const addEmployeeMutation = useMutation({
        mutationFn: (data) => request.post('/employee/addEmployee', data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['employee'] });
        },
    });

    const deleteEmployeeMutation = useMutation({
        mutationFn: (id) => request.delete('/employee/deleteEmployee', { data: { id } }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['employee'] });
        },
    });

    return {
        employees: employeeQuery?.data?.employees || [],
        isEmployeesLoading: employeeQuery.isLoading,

        addEmployee: addEmployeeMutation.mutateAsync,
        isAddingEmployee: addEmployeeMutation.isPending,

        deleteEmployee: deleteEmployeeMutation.mutateAsync,
        isDeletingEmployee: deleteEmployeeMutation.isPending,
    };
}
